var $ce65311b475a1e74$exports = {};
$ce65311b475a1e74$exports = {
    "maximum": `Maximum`,
    "minimum": `Minimum`
};


export {$ce65311b475a1e74$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
